export const seoContentGettingStartedArticle = {
  title: 'SEO Content Hub: Getting Started',
  slug: 'seo-content-getting-started',
  content: `SEO Content Hub: Getting Started

Plan topical authority, create posts, and manage your content library.

1) Open SEO Content Hub
- Go to /marketing/seo-content-hub.
- Tabs use URL hashes (#topical-authority, #blog-creator, #content-library).

2) Topical Authority
- Generate topic clusters and outlines.
- Use “Generate Post” to send a topic into Blog Creator.

3) Blog Creator
- Write and edit SEO posts with the provided workflow.

4) Content Library
- Store and review generated posts.
`,
};
